import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import { hydrate, render } from "react-dom";
import "./assets/main.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/themify-icon/themify-icons.css";
import "./assets/animate.css";
import "./assets/simple-line-icon/simple-line-icons.css";
import "./assets/font-awesome/css/all.css";
import "./assets/responsive.css";
import { render } from 'react-snapshot';
import ReactGA from 'react-ga';


// Configuración de Google Analytics
    const gaTrackingId = "G-ZH19XSWM9N"; 
    ReactGA.initialize (gaTrackingId); 
    ReactGA.pageview ("/");


    //----WITH REACT-SNAPSHOT---
    render(
      <React.StrictMode>
        
           <App />
        
      </React.StrictMode>,
      document.getElementById('root')
    );
    
    reportWebVitals();
